import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';

export function getRemixFeatureArea({
	remixType,
	existingFeatureArea,
}: {
	remixType?: string;
	existingFeatureArea?: string;
}): string | undefined {
	if (!isExperimentEnabled('maui_remix_feature_area_by_type_exp_gate')) {
		return existingFeatureArea;
	}

	return remixType ? `remix-${remixType}` : (existingFeatureArea ?? 'remix');
}
